import { Sidebar } from './Sidebar';
import { ProfileCompletionReminder } from './ProfileCompletionReminder';

export const DashboardLayout = ({ children }) => {
  return (
    <div className="min-h-screen bg-background">
      <Sidebar />
      <ProfileCompletionReminder />
      <main className="lg:pl-64">
        <div className="p-6 lg:p-8">
          {children}
        </div>
      </main>
    </div>
  );
};